import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { IConsentProgramHistory } from "@/Common/Api/Patient/Dto/IConsentProgramHistory";
import { Locale } from "@/Common/Models/Localization/Locale";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
// eslint-disable-next-line import/no-restricted-paths
import { ConsentStatus } from "@/Patient/Models/Consent/ConsentEnum";

class ConsentProgramHistory {
    private patientId: string;
    private data: IConsentProgramHistory;

    constructor(patientId: string, dto: IConsentProgramHistory) {
        this.patientId = patientId;
        this.data = dto;
    }

    public get key(): string {
        return LuxonDateTimeParser.parse(this.data.ConsentDate).toMillis().toString();
    }

    public get consentProgramCode(): string {
        return this.data.ConsentProgramCode;
    }

    public get consentProgramName(): string {
        if (sessionStore.locale === Locale.fr) {
            return this.data.ConsentProgramNameFr;
        }

        if (sessionStore.locale === Locale.en) {
            return this.data.ConsentProgramNameEn;
        }

        if (sessionStore.locale === Locale.es) {
            return this.data.ConsentProgramNameEs;
        }

        return "";
    }

    public get isDocumentationGiven(): boolean | null {
        return this.data.IsDocumentationGiven;
    }

    public get consentDate(): Date | null {
        return this.data.ConsentDate;
    }

    public get isGivenByPatient(): boolean {
        return this.patientId === this.data.GivenBy;
    }

    public get consented(): boolean {
        return this.data.Status === ConsentStatus.Consented;
    }

    public get refused(): boolean {
        return this.data.Status === ConsentStatus.Refused;
    }

    public get didNotRespond(): boolean {
        return this.data.Status === ConsentStatus.NoResponse;
    }

    public get givenToName(): string {
        if (!this.data.GivenTo)
            return "";

        const fullName = Employee.getFullNameWithPrefixContactFacet(this.data.GivenTo);

        const employee = cacheStore.GetEmployeeByContactFacetId(this.data.GivenTo);
        const license = employee?.Licences?.firstOrDefault();
        const licenseNumber = license?.LicenceNumber ?? "";

        if (licenseNumber === "") {
            return fullName;
        }

        return `${fullName} (${licenseNumber})`;
    }
}

export { ConsentProgramHistory };
